export default {
  __html: `<g fill="#292663" fill-rule="evenodd">
                <path d="M21.118 1.769H.874A.871.871 0 0 1 0 .901C0 .42.391.032.874.032h20.244c.483 0 .874.389.874.869s-.391.868-.874.868M.874 8.206A.871.871 0 0 1 0 7.338c0-.48.391-.869.874-.869h16.362c.482 0 .874.39.874.869 0 .48-.392.868-.874.868H.874zM10.054 14.637H.874A.871.871 0 0 1 0 13.768c0-.48.391-.868.874-.868h9.18c.482 0 .873.389.873.868 0 .48-.39.869-.873.869"/>
            </g>`
}
